import React from "react";
import {
  SimpleShowLayout,
  TextField,
  TextInput,
  NumberInput
} from "react-admin";

const FormTab = (props) => {
  return (
    <SimpleShowLayout {...props}>
      <TextField source="baseball.id" />
      <NumberInput source="baseball.playerGameCount" />
      <NumberInput source="baseball.hits" />
      <NumberInput source="baseball.atBats" />
      <NumberInput source="baseball.runs" />
      <NumberInput source="baseball.doubles" />
      <NumberInput source="baseball.triples" />
      <NumberInput source="baseball.homeRuns" />
      <NumberInput source="baseball.runsBattedIn" />
      <NumberInput source="baseball.stolenBases" />
      <NumberInput source="baseball.battingAverage" />
      <TextInput source="baseball.inningsPitched" />
      <NumberInput source="baseball.runsAllowed" />
      <NumberInput source="baseball.earnedRuns" />
      <NumberInput source="baseball.hitsAllowed" />
      <NumberInput source="baseball.basesOnBalls" />
      <NumberInput source="baseball.strikeouts" />
      <NumberInput source="baseball.pitchingWins" />
      <NumberInput source="baseball.pitchingLosses" />
      <NumberInput source="baseball.saves" />
      <NumberInput source="baseball.earnedRunAverage" />
    </SimpleShowLayout>
  );
};

export default FormTab;
